// extracted by mini-css-extract-plugin
export default {"container":"OpenedBetsTabEmpty_container__x7h-L","container__text":"OpenedBetsTabEmpty_container__text__eRXs4"};